import styled, {css} from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Input {
  color?: string;
  disabled?: boolean;
  isDisplay: boolean;
  error?: boolean;
  width?: number;
  height?: number;
  showOptions?: boolean;
}

interface ListOptions {
  showFirstItems?: number;
}

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  max-width: ${(props: Input) => props.width && `${props.width}px`};
  display: inline-block;
  ${(props: Input) => props.width ? `
    height: ${props.height}px`
    : `
    height: 48px;
  `};
  ${(props: Input) => props.disabled && css`
    opacity: .5;
    cursor: not-allowed;
  `}
`;

export const ListOption = styled.ul`
  outline: none;
  background: #fff;
  border-radius: 6px;
  width: 280px;
  overflow-y: scroll;
  display: ${(props: Input) => props.isDisplay ? 'block' : 'none'};
  max-height: ${(props: ListOptions) => props.showFirstItems && `${props.showFirstItems * 44}px` };
  
  & li:nth-child(2) {
    display: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    position: absolute;
    border-style: solid;
    border-width: 0 1px 1px 1px;
    border-color: ${COLORS.GRAY};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    z-index: 100;
    width: 100%;
    border-radius: 0 0 6px 6px;
    & li:nth-child(2) {
      display: block;
    }
  }
`;

export const InputMask = styled.div`
  font-family: ${FONTS.ROBOTO};
  font-size: 14px;
  cursor: pointer;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${COLORS.GRAY};
  border-radius: 6px;
  width: 100%;
  height: 100%;
  color: ${COLORS.BLACK};
  &:focus {
    outline: 0;
  }
  ${(props: Input) => props.disabled && css`
    opacity: .5;
    pointer-events: none;
  `}
  ${(props: Input) => props.error && css`
    border: 1px solid red;
  `}
  ${(props: Input) => props.showOptions && css`
    border-bottom: none;
    border-radius: 6px 6px 0 0;
    box-shadow: 0px 2px 4px rgba(0,0,0,0.25);
    svg {
      transform: rotate(180deg);
    }
  `}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 11px;
`;

export const Placeholder = styled.p`
  color: ${(props: Input) => props.color && props.color};
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LoaderWrapper = styled.span`
  right: 0;
  z-index: 10;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ListOptionModal = styled.ul`
  background: #fff;
  width: 280px;
  & li:nth-child(2) {
    display: none;
  }
`;

export const ModalTitle = styled.h3`
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 600;
  font-size: 14px;
  padding: 0 15px;
  line-height: 44px;
  border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
`;

export const Hidden = styled.select`
  display: none;
`;
